<template>
	<div>
		<div class="mp-tabbar lg:hidden" v-if="!isLoggedIn">
			<button type="button" class="mp-tab" :class="{ 'is-active': isHome }" @click="goNextPage('/',0)">
				<img class="mp-tab__icon" src="@/assets/mepay77-home/assets/icons/menu-ico/nav1.png" alt="" />
				<span>{{ $t('indexTitle.title273') }}</span>
			</button>
			<button type="button" class="mp-tab" :class="{ 'is-active': isLogin }" @click="openLogin">
				<img class="mp-tab__icon" src="@/assets/mepay77-home/assets/icons/menu-ico/nav2.png" alt="" />
				<span>{{ $t('indexTitle.title2') }}</span>
			</button>
			<button type="button" class="mp-tab mp-tab--center" :class="{ 'is-active': isRegister }" @click="openRegister">
				<span class="mp-tab__fab">
					<img src="@/assets/mepay77-home/assets/icons/menu-ico/nav3.png" alt="" />
				</span>
				<span>{{ $t('indexTitle.title1') }}</span>
			</button>
			<button type="button" class="mp-tab" :class="{ 'is-active': $route.path === '/promotions' }" @click="goNextPage('/promotions',1)">
				<img class="mp-tab__icon" src="@/assets/mepay77-home/assets/icons/menu-ico/nav4.png" alt="" />
				<span>{{ $t('indexTitle.title14') }}</span>
			</button>
			<button type="button" class="mp-tab" :class="{ 'is-active': isContact }" @click="goNextPage('/contact',1)">
				<img class="mp-tab__icon" src="@/assets/mepay77-home/assets/icons/menu-ico/nav5.png" alt="" />
				<span>{{ $t('indexTitle.title210') }}</span>
			</button>
		</div>

		<div class="mp-tabbar lg:hidden" v-else>
			<button type="button" class="mp-tab" :class="{ 'is-active': isHome }" @click="goNextPage('/',0)">
				<img class="mp-tab__icon" src="@/assets/mepay77-home/assets/icons/menu-ico/nav1.png" alt="" />
				<span>{{ $t('indexTitle.title273') }}</span>
			</button>
			<button type="button" class="mp-tab" :class="{ 'is-active': $route.path === '/vip' }" @click="goNextPage('/vip',1)">
				<img class="mp-tab__icon" src="@/assets/mepay77-home/assets/icons/menu-ico/nav2.png" alt="" />
				<span>{{ $t('indexTitle.title642') }}</span>
			</button>
			<button type="button" class="mp-tab mp-tab--center" :class="{ 'is-active': $route.path === '/mine' }" @click="goNextPage('/mine')">
				<span class="mp-tab__fab mp-tab__fab--menu">
					<img src="@/assets/mepay77-home/assets/icons/menu-ico/nav3.png" alt="" />
				</span>
				<span>{{ $t('indexTitle.title351') }}</span>
			</button>
			<button type="button" class="mp-tab" :class="{ 'is-active': $route.path === '/promotions' }" @click="goNextPage('/promotions',1)">
				<img class="mp-tab__icon" src="@/assets/mepay77-home/assets/icons/menu-ico/nav4.png" alt="" />
				<span>{{ $t('indexTitle.title14') }}</span>
			</button>
			<button type="button" class="mp-tab" :class="{ 'is-active': isContact }" @click="goNextPage('/contact',1)">
				<img class="mp-tab__icon" src="@/assets/mepay77-home/assets/icons/menu-ico/nav5.png" alt="" />
				<span>{{ $t('indexTitle.title210') }}</span>
			</button>
		</div>

		<div class="wrapper" v-if="url">
			<div class="drag-container" ref="container">
				<img src="../assets/images/home.svg" alt="" :style="{
				  position: 'absolute',
				  left: img.x + 'px',
				  top: img.y + 'px',
				  cursor: 'move',
				  userSelect: 'none',
				  width: '40px',
				  height: '40px',
				  pointerEvents: 'auto',
				  WebkitUserDrag: 'none',
				  userDrag: 'none',
				  zIndex:999	,
				}" @touchstart="startDrag" @mousedown="startDrag($event)" @click="url = ''" />
			</div>
			<iframe :src="url"></iframe>
		</div>
	</div>
</template>

<script>
	import { eventBus } from '@/App.vue'
	import {
		getsystemconfig,
	} from "../utils/api.js";
	export default {
		props: {
			isSelNav: Number
		},
		data() {
			return {
				img: {
					x: 40,
					y: 60
				},
				isDragging: false,
				offsetX: 0,
				offsetY: 0,
				dragMask: null,
				systemconfig: {},
				isLoadingShow: false,
				kefushow: false,
				url: "",
				currentPath:"",
				isLoggedIn: !!localStorage.getItem('token'),
			}
		},
		created() {
			this.$bus.$on('openUrlModal', () => {
			    this.url = 'https://www.baidu.com'
			})
			this.$bus.$on('loginStateChanged', this.syncLoginState)
			this.$bus.$on('refreshUserInfo', this.syncLoginState)
		},
		beforeDestroy() {
		    this.$bus.$off('openUrlModal')
			this.$bus.$off('loginStateChanged', this.syncLoginState)
			this.$bus.$off('refreshUserInfo', this.syncLoginState)
		},
		mounted() {
			this.getSystemconfig()
			this.syncLoginState()
			window.location.href.indexOf("?show") > -1 ? this.isLoadingShow = true : ''
			
			this.currentPath = this.$route.path
			    this.$watch('$route.path', (to) => {
			      this.currentPath = to
			    })
				
		},
		computed: {
			isHome() {
				return this.$route.path === '/index' || this.$route.path === '/'
			},
			isRegister() {
				return this.$route.path === '/register'
			},
			isLogin() {
				return this.$route.path === '/login'
			},
			isContact() {
				return this.$route.path === '/contact'
			}
		},
		methods: {
			syncLoginState() {
				this.isLoggedIn = !!localStorage.getItem('token')
			},
			getKefu(){
				this.$router.push('/contact')
			},
			openLogin() {
				this.$router.push('/login')
			},
			openRegister() {
				this.$router.push('/register')
			},
			toggleLeft() {
				eventBus.$emit('toggleLeft')
			},
			getEventClientXY(e) {
				if (e.type.startsWith('touch')) {
					const touch = e.touches[0] || e.changedTouches[0];
					return {
						x: touch.clientX,
						y: touch.clientY
					};
				} else {
					return {
						x: e.clientX,
						y: e.clientY
					};
				}
			},

			startDrag(e) {
				const imgRect = e.target.getBoundingClientRect();
				const {
					x: clientX,
					y: clientY
				} = this.getEventClientXY(e);
				this.isDragging = true;
				this.offsetX = clientX - imgRect.left;
				this.offsetY = clientY - imgRect.top;
				if (!this.dragMask) {
					this.dragMask = document.createElement('div');
					this.dragMask.style.cssText = `
			        position: fixed;
			        top: 0; left: 0;
			        width: 100vw; height: 100vh;
			        z-index: 99998;
			        pointer-events: none;
			      `;
					document.body.appendChild(this.dragMask);
				}
				document.addEventListener('mousemove', this.onDragMove);
				document.addEventListener('touchmove', this.onDragMove, {
					passive: false
				});
				document.addEventListener('mouseup', this.stopDrag);
				document.addEventListener('touchend', this.stopDrag);
			},
			onDragMove(e) {
				if (!this.isDragging) return;
				e.preventDefault();
				const {
					x: clientX,
					y: clientY
				} = this.getEventClientXY(e);
				const containerRect = this.$refs.container.getBoundingClientRect();

				let newX = clientX - this.offsetX;
				let newY = clientY - this.offsetY;

				newX = Math.max(0, Math.min(newX, containerRect.width - 40));
				newY = Math.max(0, Math.min(newY, containerRect.height - 40));

				this.img.x = newX;
				this.img.y = newY;
			},

			stopDrag() {
				this.isDragging = false;
				document.removeEventListener('mousemove', this.onDragMove);
				document.removeEventListener('touchmove', this.onDragMove);
				document.removeEventListener('mouseup', this.stopDrag);
				document.removeEventListener('touchend', this.stopDrag);

				if (this.dragMask) {
					document.body.removeChild(this.dragMask);
					this.dragMask = null;
				}
			},
			getSystemconfig() {
				getsystemconfig({}).then((res) => {
					if (res.status.errorCode == 0) {
						this.systemconfig = res.data
					}
				}).catch(() => {})
			},
			goNextPage(page) {
				if (
					(!localStorage.getItem("token") && page == "/deposit") ||
					(!localStorage.getItem("token") && page == "/withdraw")
				) {
					this.$bus.$emit('openLoginModal')
					return false;
				}
				this.$router.push(page)
			},
		}
	}
</script>
<style scoped>
	.wrapper {
		position: fixed;
		inset: 0;
		z-index: 99990;
		background: #000;
	}
	.wrapper iframe {
		width: 100%;
		height: 100%;
		border: 0;
	}
	.drag-container {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		z-index: 9999;
		pointer-events: none;
	}

	.drag-container img {
		pointer-events: auto;
	}

	.mp-tabbar {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 105;
		display: grid;
		grid-template-columns: repeat(5, 1fr);
		align-items: center;
		min-height: 42px;
		padding: 2px 4px 3px;
		background: var(--mp-gradient-tab);
		box-shadow: 0 -4px 18px rgba(0, 0, 0, 0.35);
	}
	.mp-tab {
		border: 0;
		background: transparent;
		color: rgba(255, 255, 255, 0.92);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 1px;
		padding: 0;
		font-size: 9px;
		line-height: 1.05;
		min-height: 36px;
		align-self: center;
	}
	.mp-tab__icon {
		width: 24px;
		height: 24px;
		object-fit: contain;
		display: block;
	}
	.mp-tab.is-active {
		color: #fff;
		font-weight: 700;
	}
	.mp-tab--center {
		position: relative;
		top: -10px;
		align-self: end;
		justify-content: flex-end;
	}
	.mp-tab__fab {
		position: relative;
		width: 36px;
		height: 36px;
		border-radius: 50%;
		background: var(--mp-gradient-fab, radial-gradient(circle at 35% 30%, #67e8f9 0%, #22d3ee 45%, #10b981 100%));
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.35), 0 0 0 3px rgba(255, 255, 255, 0.18);
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 0;
		overflow: hidden;
	}
	.mp-tab__fab--menu {
		background: var(--mp-gradient-fab, radial-gradient(circle at 35% 30%, #67e8f9 0%, #22d3ee 45%, #10b981 100%));
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.35), 0 0 0 3px rgba(34, 211, 238, 0.35);
	}
	.mp-tab__fab img {
		width: 20px;
		height: 20px;
		object-fit: contain;
		display: block;
	}
</style>
